import * as types from './mutation-types'
// import Vue from 'vue'
import {
  kpiUserGetUserCenterInitInfo,
  kpiUserGetPermissions,
  kpiCustomerGetSettings,
  kpiThemeCurrent, kpiCustomerGetSettingsAndPermission
} from 'api'
import {kpiGetAMapKey} from "@/api";
import {UPDATE_AMAP_KEY} from "./mutation-types";
import {syncTrainUnitApiPrefixFromSettings} from "@/common/utility/trainApiPrefix";

/** 个人信息 */
export const dispatchPersonalInfo = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    kpiUserGetUserCenterInitInfo({}).then((res) => {
      commit(types.UPDATE_PERSONAL_INFOR, res.ResultData)
      resolve(state.PersonalInfor)
    }).catch((err) => {
      reject(err)
    })
  })
  return promise
}

/** 权限 */
export const dispatchPersonalPower = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    kpiUserGetPermissions({}).then((res) => {
      commit(types.UPDATE_PERSONAL_POWER, res.ResultData)
      resolve(state.PersonalPower)
    }).catch((err) => {
      reject(err)
    })
  })
  return promise
}

/** 设置 */
export const dispatchPersonalSetting = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    kpiCustomerGetSettings({}).then((res) => {
      commit(types.UPDATE_PERSONAL_SETTING, res.ResultData)
      syncTrainUnitApiPrefixFromSettings(res.ResultData)
      resolve(state.PersonalSetting)
    }).catch((err) => {
      reject(err)
    })
  })
  return promise
}

/** 获取权限配置公共接口 */
export const dispatchSettingAndPower = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    kpiCustomerGetSettingsAndPermission({}).then((res) => {
      let data = res.ResultData
      // 更新权限
      commit(types.UPDATE_PERSONAL_POWER, data.Permission)
      // 更新配置（接口字段为 Settings；兼容旧 Setting）
      const settings = data.Settings || data.Setting
      commit(types.UPDATE_PERSONAL_SETTING, settings)
      syncTrainUnitApiPrefixFromSettings(settings)
      resolve(data)
    }).catch((err) => {
      reject(err)
    })
  })
  return promise
}

/** 获取主题 */
export const dispatchTheme = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    kpiThemeCurrent({}).then((res) => {
      console.log('------获取主题------', res)
      commit(types.UPDATE_THEME_SETTING, res.ResultData)
      resolve(state.Theme)
    }).catch((err) => {
      reject(err)
    })
  })
  return promise
}

export const dispatchAMapKey = function({commit, state}) {
  let promise = new Promise(function(resolve, reject) {
    if (state.AMapKey.key) {
      resolve(state.AMapKey)
    } else {
      kpiGetAMapKey().then((res) => {
        if (res.ResultData) {
          let data = res.ResultData.MapKey ? res.ResultData.MapKey : {}
          commit(types.UPDATE_AMAP_KEY, {
            key: data.Key,
            securityJsCode: data.Secret,
            MapSource: res.ResultData.MapSource , // 地图来源 1 高德 2 天地图
          })
          resolve(state.AMapKey)
        }
      }).catch((err) => {
        reject(err)
      })
    }
  })
  return promise
}
